import { CALL_API } from '../../middleware/api';
import * as ActionTypes from '../accountHistory';
var fetchAccountHistory = function (data) {
    var _a;
    return (_a = {
            type: ActionTypes.FETCH_ACCOUNT_HISTORY
        },
        _a[CALL_API] = {
            endpoint: "/api/gambler/reporting/operations?startdate=".concat(data.startDate, "&enddate=").concat(data.finishDate, "&languageId=").concat(data.languageId === 13 ? 5 : data.languageId),
            method: 'get',
            types: [ActionTypes.SUCCESS_FETCH_ACCOUNT_HISTORY, ActionTypes.FAILURE_FETCH_ACCOUNT_HISTORY],
        },
        _a);
};
export var clearAccountHistory = function () {
    return { type: ActionTypes.CLEAR_ACCOUNT_HISTORY };
};
export function getAccountHistory(data) {
    return function (dispatch, getState) {
        data['languageId'] = getState().application.get('languageId');
        return dispatch(fetchAccountHistory(data));
    };
}



// WEBPACK FOOTER //
// ./src/actions/creators/accountHistory.js